import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { Box } from "reflexbox/styled-components";
import { useRegisterStateValue } from "../RegisterContext";
import { registerScreens } from "../../util/util";
import RenderIf from "../../common/conditions/RenderIf";
import RegisterHeader from "../register-header/RegisterHeader";
import PurchaserScreen from "./purchaser/PurchaserScreen";
import AttenderScreen from "./attenders/AttenderScreen";
import RegistrationFeeScreen from "./registration-fee/RegistrationFeeScreen";
import VerificationScreen from "./verification/VerificationScreen";
import AccreditationHome from "./accreditation-home/AccreditationHome";
import QrCode from "./qr-code/QrCode";
import WirePayment from "./wire-payment/WirePayment";
import EPayment from "./e-payment/EPayment";
import { Spin } from "antd";
import { Flex } from "reflexbox/src";
import ConfirmTerms from "./confirm-terms/ConfirmTerms";

const StyledLayoutContainer = styled(Box)`
    height: ${({ innerHeaderActive }) => (innerHeaderActive ? "calc(100% - 80px)" : "100%")};
    margin-top: ${({ innerHeaderActive }) => (innerHeaderActive ? "80px" : "unset")};
    overflow-y: auto;
    scroll-behavior: smooth;
    .required-label {
        color: ${({ theme }) => theme.colors.white};
        font-size: ${({ theme }) => theme.fontSizes[0]}px;
        text-align: left;
        margin-bottom: ${({ theme }) => theme.space[4]}px;
        &.first {
            margin-top: ${({ theme }) => theme.space[3]}px;
            margin-bottom: ${({ theme }) => theme.space[2]}px;
        }
    }
`;

const SpinContainer = styled(Flex)`
    justify-content: center;
    align-items: center;
    flex: 1;
    flex-direction: column;
`;

const RegisterContent = () => {
    const { currentScreen, loading } = useRegisterStateValue();
    const ref = useRef(null);

    const scrollToTop = () => {
        ref.current.scrollTop = 0;
    };

    useEffect(() => scrollToTop(), [currentScreen]);

    return (
        <>
            {currentScreen !== registerScreens.ACCREDITATION_START &&
                currentScreen !== registerScreens.QR_CODE &&
                currentScreen !== registerScreens.PURCHASER &&
                currentScreen !== registerScreens.MONRI_PAGE &&
                currentScreen !== registerScreens.SUCCESSFUL_WIRE_PAYMENT &&
                currentScreen !== registerScreens.CONFIRM_TERMS && <RegisterHeader />}
            <StyledLayoutContainer
                innerHeaderActive={
                    currentScreen !== registerScreens.ACCREDITATION_START &&
                    currentScreen !== registerScreens.QR_CODE &&
                    currentScreen !== registerScreens.PURCHASER &&
                    currentScreen !== registerScreens.MONRI_PAGE &&
                    currentScreen !== registerScreens.SUCCESSFUL_WIRE_PAYMENT &&
                    currentScreen !== registerScreens.CONFIRM_TERMS
                }
                ref={ref}>
                {loading ? (
                    <SpinContainer>
                        <Spin />
                    </SpinContainer>
                ) : (
                    <>
                        <RenderIf if={currentScreen === registerScreens.ACCREDITATION_START} render={AccreditationHome} />
                        <RenderIf if={currentScreen === registerScreens.PURCHASER} render={PurchaserScreen} />
                        <RenderIf if={currentScreen === registerScreens.ATTENDERS} render={AttenderScreen} />
                        <RenderIf if={currentScreen === registerScreens.REGISTRATION_FEE} render={RegistrationFeeScreen} />
                        <RenderIf if={currentScreen === registerScreens.VERIFICATION} render={VerificationScreen} />
                        <RenderIf if={currentScreen === registerScreens.QR_CODE} render={QrCode} />
                        <RenderIf if={currentScreen === registerScreens.SUCCESSFUL_WIRE_PAYMENT} render={WirePayment} />
                        <RenderIf if={currentScreen === registerScreens.MONRI_PAGE} render={EPayment} />
                        <RenderIf if={currentScreen === registerScreens.CONFIRM_TERMS} render={ConfirmTerms} />
                    </>
                )}
            </StyledLayoutContainer>
        </>
    );
};

export default RegisterContent;
